import React from "react";
import FetchHelper from "./fetchHelper";
import ConfirmDialog from "./confirmDialog";
/**
 * The confirmation before a volunteer takes their own byttevagt back off the exchange - shared by
 * the ✕ on Mine byttevagter and the one on the schedule row and shift page.
 *
 * Always asks, because cancelling cannot be undone and lapses every other volunteer's offer on the
 * byttevagt, texting each of them. When the same shift is also one of the volunteer's own swap
 * offers somewhere else, it asks the real question: cancelling says they mean to keep the shift,
 * but those offers could still be accepted out from under them - so do they want them back too?
 *
 * The count is fetched when the dialog opens rather than carried on every byttevagt: only this
 * moment needs it, and the pages that render a byttevagt do so from several different view models.
 */
export default class CancelExchangeConfirm extends React.Component {
    constructor(props) {
        super(props);
        this.cancel = (withdrawRelatedOffers) => {
            this.setState({ busy: true });
            FetchHelper.put(`/bpapi/shiftexchange/cancel`, {
                shiftExchangeId: this.props.shiftExchangeId,
                withdrawRelatedOffers
            })
                .then(() => this.props.onCancelled())
                .catch(() => {
                this.setState({ busy: false });
                this.props.onError("Byttevagten kunne ikke trækkes tilbage");
            });
        };
        this.state = { loaded: false, count: 0, busy: false };
    }
    componentDidMount() {
        FetchHelper.get(`/bpapi/shiftswap/own-offers-using/${this.props.shiftMemberId}`)
            .then((result) => { var _a; return this.setState({ loaded: true, count: (_a = result.count) !== null && _a !== void 0 ? _a : 0 }); })
            // The count only decides which question to ask. Without it, ask the plain one - which
            // cancels the byttevagt and leaves the offers alone, the safe default.
            .catch(() => this.setState({ loaded: true, count: 0 }));
    }
    render() {
        if (!this.state.loaded)
            return null;
        const count = this.state.count;
        return count > 0
            ? React.createElement(ConfirmDialog, { heading: "Tr\u00E6k byttevagten tilbage", message: count === 1
                    ? "Vagten indgår også i et af dine bytteforslag. Vil du også trække den tilbage derfra?"
                    : `Vagten indgår også i ${count} af dine bytteforslag. Vil du også trække den tilbage derfra?`, yesLabel: "Ja, tr\u00E6k ogs\u00E5 mine bytteforslag tilbage", extra: { label: "Nej, kun byttevagten", onClick: () => this.cancel(false) }, noLabel: "Fortryd", busy: this.state.busy, onYes: () => this.cancel(true), onNo: this.props.onClose })
            : React.createElement(ConfirmDialog, { heading: "Tr\u00E6k byttevagten tilbage", message: "Vil du tr\u00E6kke byttevagten tilbage?", busy: this.state.busy, onYes: () => this.cancel(false), onNo: this.props.onClose });
    }
}
